import type { NodeV2Style } from '@vedalib/editor'
import { useMemo } from 'react'
import React from 'react'

import type { PxSizesValueType } from '../formControls/Sizes/types'
import { applyPxSizes, safeParsePxSizes } from '../formControls/Sizes/utils'
import * as s from './Controls.module.scss'

interface INodeV2SelectionProps {
  children: React.ReactNode
  styles?: NodeV2Style | null
}

const NodeV2Selection: React.FC<INodeV2SelectionProps> = ({ children, styles }) => {
  const inset = useMemo(() => {
    const invert = safeParsePxSizes(styles?.margin).map((v) => -(v || 0))
    return applyPxSizes(invert as PxSizesValueType) || undefined
  }, [styles])

  return (
    <div className={s.selection} style={{ inset }}>
      {children}
    </div>
  )
}

export default React.memo(NodeV2Selection)
